import { useEffect, useState } from "react";
import "./Profile.css";
import { Helmet } from "react-helmet-async";

const Profile = ({ dark, user, setUser }) => {
  const [profile, setProfile] = useState(user || null);

  useEffect(() => {
    if (user) {
      setProfile(user);
    }
  }, [user]);

  const logout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("authUser");
    document.cookie =
      "authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    
    // Clear user state in App.js
    if (setUser) {
      setUser(null);
    }
    
    window.location.href = "/login";
  };

  const initials = profile?.name
    ? profile.name
        .split(" ")
        .map((item) => item[0])
        .join("")
        .slice(0, 2)
        .toUpperCase()
    : "U";

  return (
    <div
      className={`profile-page`}
    >
      <Helmet>
        <title>My Profile | FadaSports User Account</title>
        <meta name="description" content="Manage your FadaSports profile, account settings, favorites, and preferences." />
        <meta name="keywords" content="profile, account, user account, settings, favorites" />
        <meta name="author" content="FadaSports" />
        <meta name="robots" content="noindex, follow" />
        <meta property="og:title" content="My Profile" />
        <meta property="og:description" content="FadaSports user profile and account management." />
        <meta property="og:image" content="https://fadasports.com/static/media/mobilelogo.d0257d49e02d3094cce0.png" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="FadaSports" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@FadaSports" />
      </Helmet>
      <div className="profile-wrapper">
        <div className="profile-card" style={dark ? {backgroundColor: "#1d1e20ff"} : {backgroundColor: "#fafafaff"}}
        >
          <div className="profile-banner">
            <img src={profile?.photo} alt="" />
          </div>

          <div className="profile-avatar">
            {initials}
          </div>

          <div className="profile-content">
            <h1>
              {profile?.name || "Guest User"}
            </h1>

            <p className="profile-email" style={dark ? {} : {color: "#3e3f3f"}}>
              {profile?.email ||
                "No email available"}
            </p>

            <div className="profile-grid">
              <div className="profile-box" style={dark ? {backgroundColor: "#232733"} : {backgroundColor: "white"}}>
                <span style={dark ? {} : {color: "#3e3f3f"}}>ID</span>
                <strong style={dark ? {} : {color: "#3e3f3f"}}>
                  {profile?.id || "--"}
                </strong>
              </div>

              <div className="profile-box" style={dark ? {backgroundColor: "#232733"} : {backgroundColor: "white"}}>
                <span style={dark ? {} : {color: "#3e3f3f"}}>Status</span>
                <strong style={dark ? {} : {color: "#3e3f3f"}}>
                  Authenticated
                </strong>
              </div>

              <div className="profile-box" style={dark ? {backgroundColor: "#232733"} : {backgroundColor: "white"}}>
                <span style={dark ? {} : {color: "#3e3f3f"}}>Member Since</span>
                <strong style={dark ? {} : {color: "#3e3f3f"}}>
                  {profile?.created_at
                    ? new Date(
                        profile.created_at
                      ).toLocaleDateString()
                    : "--"}
                </strong>
              </div>

              <div className="profile-box" style={dark ? {backgroundColor: "#232733"} : {backgroundColor: "white"}}>
                <span style={dark ? {} : {color: "#3e3f3f"}}>Theme</span>
                <strong style={dark ? {} : {color: "#3e3f3f"}}>
                  {dark
                    ? "Dark Mode"
                    : "Light Mode"}
                </strong>
              </div>
            </div>

            <div className="profile-actions">
              <button className="edit-btn">
                Edit Profile
              </button>

              <button
                className="logout-btn"
                onClick={logout}
              >
                Logout
              </button>
            </div>
          </div>
        </div>

        <div className="profile-side-card" style={dark ? {backgroundColor: "#171a21"} : {backgroundColor: "#fafafaff"}}>
          <h3 style={dark ? {} : {color: "#161819"}}>About Account</h3>

          <p style={dark ? {} : {color: "#3e3f3f"}}>
            This is your personal profile
            dashboard. Manage account
            settings, monitor activity,
            and personalize your sports
            experience.
          </p>

          <div className="side-stats">
            <div style={dark ? {backgroundColor: "#232733"} : {backgroundColor: "white"}}>
              <span style={dark ? {} : {color: "#3e3f3f"}}>Security</span>
              <strong style={dark ? {} : {color: "#3e3f3f"}}>Strong</strong>
            </div>

            <div style={dark ? {backgroundColor: "#232733"} : {backgroundColor: "white"}}>
              <span style={dark ? {} : {color: "#3e3f3f"}}>Plan</span>
              <strong style={dark ? {} : {color: "#3e3f3f"}}>Free</strong>
            </div>

            <div style={dark ? {backgroundColor: "#232733"} : {backgroundColor: "white"}}>
              <span style={dark ? {} : {color: "#3e3f3f"}}>Activity</span>
              <strong style={dark ? {} : {color: "#3e3f3f"}}>Active</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;